// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__4d3Ug","inner":"Footer_inner__1qXHU"};